import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuModel } from '../../models/common/menu.model';
import { AuthenticationService } from '../../services/authentication.service';
import { CurrentUser } from '../../models/current-user.model';
import { AutoRecordMaster } from '../../models/auto-record-master.model';
import { DialogOfficeSelectionComponent } from "./dialog-office-selection/dialog-office-selection.component";
import { environment } from '../../../environments/environment';

@Component({
  selector: 'careposi-header',
  standalone: true,
  imports: [CommonModule, DialogOfficeSelectionComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit , OnDestroy{
  userName = "";
  officeName = "";
  userAvatar = "images/no_avatar.png";
  officeSub :any;
  currentUserSub :any;
  infoCollapsed = false;
  accessToken = "";
  refreshToken = "";
  @Output() logoutHandler = new EventEmitter<any>();
  dataEdit: AutoRecordMaster = {};
  isShowDialog = false;
  constructor(
    private authService: AuthenticationService,
  ) {
    this.officeSub = this.authService.officeSelected.subscribe((office) => {
      this.officeName = office?.officenm ?? "";
    });
    this.currentUserSub = this.authService.currentUser.subscribe((user: CurrentUser | null) => {
        this.userName = user?.fullName ? user?.fullName : (user?.lastName ?? "") + " " + (user?.firstName ?? "");
        this.accessToken = user?.accessToken ?? "";
        this.refreshToken = user?.refreshToken ?? "";
    });

  }
  ngOnDestroy(): void {
    if (this.officeSub) this.officeSub.unsubscribe();
    if (this.currentUserSub) this.currentUserSub.unsubscribe();
  }

  ngOnInit(): void {

  }

  handleSidebarToggle(event: any) {


  }

  isActiveRoute(menu: MenuModel) {

  }


  setLabelForMenu() {

  }


  onLogout() {
    this.logoutHandler.emit();
  }
  onProfile() {

  }

  toggleInfoPanel() {
    this.infoCollapsed = !this.infoCollapsed;
  }
  gotoProfile() {
    this.authService.refreshToken(this.refreshToken).then((result: any) => {
        if (result !== null) {
          window.open(`${environment.CKPASS_ACCOUNT_INFO}?accessToken=${this.authService.currentUserValue?.accessToken}&refreshToken=${this.authService.currentUserValue?.refreshToken}`,"_blank");
        }
        else {
          this.onLogout();
        }
    });
  }
  showChangeOffice(){
    this.dataEdit = {};
    this.isShowDialog = true;
  }
  async onSubmitData(event: any) {
    this.isShowDialog = false;
    if (event == null) { return}
  }
}
